import isFinite from 'lodash/isFinite';
import * as React from 'react';
import styled from 'styled-components';
import { Column } from '../layout/Column';

interface IProps {
  value: number | string;
  units?: string;
  label?: string;
  isSecondary?: boolean;
  rightAlign?: boolean;
  large?: boolean;
  style?: React.CSSProperties;
  isBoolean?: boolean;
}

export const Metric = (props: IProps): React.ReactElement => {
  return (
    <Column style={props.style}>
      {props.label && <MetricLabel>{props.label}</MetricLabel>}
      <MetricValueRow rightAlign={props.rightAlign}>
        {props.isSecondary ? (
          <SecondaryValue>
            {isFinite(props?.value) ? props.value : '--'}
          </SecondaryValue>
        ) : (
          <MetricValue large={props.large}>{displayValue(props)}</MetricValue>
        )}
        {props.units &&
          Boolean(props.value) &&
          typeof props?.value === 'number' && (
            <MetricUnit large={props.large}>{props.units}</MetricUnit>
          )}
      </MetricValueRow>
    </Column>
  );
};

const displayValue = (metric: IProps): number | string => {
  /// check for boolean metric
  if (metric.isBoolean === true && (metric.value === 0 || metric.value === 1)) {
    if (metric.value === 0) {
      return 'No';
    } else {
      return 'Yes';
    }
  } else if (isFinite(metric.value)) {
    return metric.value;
  } else {
    return '--';
  }
};

const MetricValueRow = styled.div`
  display: flex;
  flex-direction: row;
  align-items: baseline;
  justify-content: ${(props: { rightAlign: boolean }): string =>
    props.rightAlign ? 'flex-end' : 'flex-start'};
`;

const MetricValue = styled.h4<{ large?: boolean }>`
  font-weight: bold;
  color: var(--color-metric-value);
  font-family: 'Roboto';
  text-shadow: 1px 1px 1px var(--color-text-shadow);
  font-size: ${(props: { large?: boolean }): string =>
    props.large
      ? '10rem !important'
      : 'calc(18px + (30 - 20) * ((100vw - 300px) / (1600 - 300)))'};
`;

const SecondaryValue = styled.h6`
  font-family: 'Roboto';
  font-weight: bold;
  color: var(--color-secondary-text);
`;

const MetricUnit = styled.div<{ large?: boolean }>`
  margin-left: 3px;
  font-size: ${(props: { large?: boolean }): string =>
    props.large ? '8rem !important' : 'inherit'};
`;

const MetricLabel = styled.div``;
